module.exports = __webpack_public_path__ + "img/medal7.d3cf36bd.png";